import { Disposable } from '../utils/Disposable.js';
import { ON_ALL_UNSUBSCRIBED } from './BaseQuery.js';
export class QueryCache extends Disposable {
    constructor({ evictionTime = 5 * 1000, context, }) {
        super();
        this._cache = new Map();
        this.onQueryUnsubscribed = (query) => {
            setTimeout(() => {
                if (query.subscribed)
                    return;
                // double check before evicting... possible the cache
                // got a different version of this query.
                if (this._cache.get(query.key) === query) {
                    this._cache.delete(query.key);
                }
            }, this._evictionTime);
        };
        this.dropAll = () => {
            this._cache.forEach((query) => query.dispose());
            this._cache.clear();
        };
        this._evictionTime = evictionTime;
        this.context = context;
    }
    get(key) {
        return this._cache.get(key) || null;
    }
    set(value) {
        this._cache.set(value.key, value);
        value[ON_ALL_UNSUBSCRIBED](this.onQueryUnsubscribed);
        return value;
    }
    getOrSet(key, create, update) {
        const existing = this.get(key);
        if (existing) {
            update === null || update === void 0 ? void 0 : update(existing);
            return existing;
        }
        return this.set(create());
    }
}
//# sourceMappingURL=QueryCache.js.map